import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  Button,
} from 'reactstrap';
import { Title, LoadingCard, PageHeader, Stopwatch } from '../Shared';
import {
  locationActions,
  locationEquipmentActions,
  leaderboardActions,
  eventActions,
} from '../_actions';
import isEmpty from 'lodash/isEmpty';
import tipsRules from './tipsandrules.png';
import viewLeaderboards from './viewleaderboards.png';
import futureEvents from './eefutureevents.png';
import ReactPlayer from 'react-player';
import arrowLeft from './arrowleft.png';
import arrowRight from './arrowright.png';
import classnames from 'classnames';
import { date } from '../_helpers';
import clock from './clock.png';
import calendar from './calendar.png';
import clockButton from './clock-btn.png';

export const LeaderBoardPane = (props) => {
  return (
    <Container>
      {!isEmpty(props.data) ? (
        <>
          {props.data.map((res, idx) => (
            <Row style={{ paddingTop: 5 }} key={idx}>
              <Col
                style={{
                  backgroundColor: '#F2F2F2',
                  width: '100%',
                  height: 30,
                  borderRadius: 20,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      backgroundColor: '#949494',
                      width: 30,
                      height: 30,
                      marginLeft: -15,
                      borderRadius: 20,
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                    }}
                  >
                    <small
                      style={{
                        fontWeight: '600',
                        fontSize: '0.6rem',
                        color: '#fff',
                      }}
                    >
                      {idx + 1 < 10 ? `0${idx + 1}` : `${idx + 1}`}
                    </small>
                  </div>
                  <small
                    style={{
                      fontWeight: '500',
                      paddingLeft: 5,
                      fontSize: '0.6rem',
                    }}
                  >
                    {res.user.userName}
                  </small>
                </div>
                <div></div>
                <div className={'text-left'} style={{ minWidth: 135 }}>
                  <img src={calendar} alt="calendar" />
                  <small className="pl-1" style={{ fontSize: '0.6rem' }}>
                    {date.getShortDate(res.timeStarted)}
                  </small>
                  <img src={clock} className="pl-2" alt="clock" />
                  <small className="pl-1" style={{ fontSize: '0.6rem' }}>
                    {res.tsDuration}
                  </small>
                </div>
              </Col>
            </Row>
          ))}
        </>
      ) : (
        <div className="no-times text-center">No times recorded</div>
      )}
    </Container>
  );
};

export const EventPane = (props) => {
  const history = useHistory();
  let visible;
  if (props.data && !isEmpty(props.data.events)) {
    visible = props.data.events.filter((x) => x.location.id === props.singleId);
  } else {
    visible = null;
  }

  return (
    <Container>
      {visible && !isEmpty(visible) ? (
        <>
          {visible.map((res, idx) => (
            <Row
              key={idx}
              style={{ paddingTop: 5 }}
              onClick={() => history.push(`/Events?eventId=${res.id}`)}
            >
              <Col
                style={{
                  backgroundColor: '#ffffff',
                  width: '100%',
                  height: 30,
                  borderRadius: 20,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <small style={{ fontWeight: '500', fontSize: '0.6rem' }}>
                    {res.location.city}
                  </small>
                </div>
                <div></div>
                <div>
                  <img src={calendar} alt="calendar" />
                  <small className="pl-1" style={{ fontSize: '0.60rem' }}>
                    {date.getShortDate(res.startTime)}
                  </small>
                  <img src={clock} className="pl-2" alt="clock" />
                  <small className="pl-1" style={{ fontSize: '0.60rem' }}>
                    {date.getTimeAmPm(res.startTime)}
                  </small>
                </div>
              </Col>
            </Row>
          ))}
        </>
      ) : (
        <div className="no-times text-center">No events found</div>
      )}
    </Container>
  );
};

class LocationSingle extends React.Component {
  state = {
    isOpen: false,
    equipmentId: null,
    currentEquipment: null,
    tab: 'casual',
    eventTab: 'upcoming',
    upcoming: null,
    past: null,
  };
  toggle = (e, id) => {
    if (id) {
      this.setState({ equipmentId: id });
    }
    this.setState({ isOpen: !this.state.isOpen });
  };

  saveTime = (data) => {
    const locationId = this.props.single.id;
    const { timeStarted, timeCompleted, runningTime } = data;
    this.props.addToLeaderboard({
      locationId,
      timeStarted,
      timeCompleted,
      duration: runningTime,
    });
  };

  equipmentIndex = () => {
    const { equipment } = this.props;
    const { equipmentId } = this.state;
    return {
      index: equipment.findIndex((e) => e.id === equipmentId),
      arrLen: equipment.length - 1,
    };
  };

  next = () => {
    const res = this.equipmentIndex();
    let next;
    if (res.index === res.arrLen) {
      next = this.props.equipment[0];
    } else {
      next = this.props.equipment[res.index + 1];
    }
    this.setState({
      equipmentId: next.id,
      currentEquipment: this.props.equipment.find((e) => e.id === next.id),
    });
  };

  prev = () => {
    const res = this.equipmentIndex();
    let prev;
    if (res.index === 0) {
      prev = this.props.equipment[res.arrLen];
    } else {
      prev = this.props.equipment[res.index - 1];
    }
    this.setState({
      equipmentId: prev.id,
      currentEquipment: this.props.equipment.find((e) => e.id === prev.id),
    });
  };

  componentDidMount = () => {
    const { path } = this.props.match.params;
    if (path) {
      this.props.getLocation(path);
      this.props.equipmentForSite(path);
      this.props.getLeaderboard(path);
      this.props.getUpcoming();
      this.props.getPast();
    }
  };

  componentDidUpdate(prevProps) {
    if (this.state.equipmentId === null && !isEmpty(this.props.equipment)) {
      this.setState({
        equipmentId: this.props.equipment[0].id,
        currentEquipment: this.props.equipment.find(
          (e) => e.id === this.props.equipment[0].id,
        ),
      });
    }
  }

  render() {
    const {
      single,
      loading,
      equipment,
      official,
      unofficial,
      user,
      didRegister,
      timeSaved,
      upcoming,
      past,
    } = this.props;
    return (
      <div
        style={{
          flex: 1,
          backgroundColor: '#F2F2F2',
          minHeight: `calc(100vh)`,
        }}
      >
        <Title text={isEmpty(single) ? 'Loading' : single.name} />
        <PageHeader className="locations pb-3">
          <Row>
            {loading && <LoadingCard />}
            {!loading && !isEmpty(single) && (
              <Fragment>
                <Col xs={12}>
                  <h3 className="orange-title text-center">
                    Park Warrior @ {single.name}
                  </h3>
                  <p
                    className="lead text-center"
                    style={{
                      color: '#888888',
                      fontSize: '0.85rem',
                      paddingTop: 10,
                    }}
                  >
                    {single.location}
                  </p>
                </Col>
              </Fragment>
            )}
          </Row>
          <Row style={{ flexDirection: 'space-between', paddingTop: 30 }}>
            <Col>
              <div className={'text-center'}>
                <a href="#tips-and-rules" className={'text-center'}>
                  <img src={tipsRules} alt="tips and rules" />
                  <p
                    style={{
                      lineHeight: '1rem',
                      paddingTop: 10,
                      color: '#212529',
                    }}
                  >
                    <small>
                      Tips and
                      <br />
                      Rules
                    </small>
                  </p>
                </a>
              </div>
            </Col>
            <Col>
              <div className={'text-center'}>
                <a href="#leaderboard" className={'text-center'}>
                  <img src={viewLeaderboards} alt="view leaderboards" />
                  <p
                    style={{
                      lineHeight: '1rem',
                      paddingTop: 10,
                      color: '#212529',
                    }}
                  >
                    <small>
                      View
                      <br />
                      Leaderboards
                    </small>
                  </p>
                </a>
              </div>
            </Col>
            <Col>
              <div className={'text-center'}>
                <a href="#events" className={'text-center'}>
                  <img src={futureEvents} alt="future events" />
                  <p
                    style={{
                      lineHeight: '1rem',
                      paddingTop: 10,
                      color: '#212529',
                    }}
                  >
                    <small>
                      See Future
                      <br />
                      Events
                    </small>
                  </p>
                </a>
              </div>
            </Col>
          </Row>
        </PageHeader>

        <Container id="tips-and-rules" className="mt-4">
          <Row className="mt-2">
            <Col>
              <p className="orange-title text-center">Tips and Rules</p>
              <p className="text-center" style={{ lineHeight: '1rem' }}>
                <small>
                  Instructions and Tip and Rules for
                  <br />
                  this location are listed below.
                </small>
              </p>
            </Col>
          </Row>
        </Container>

        {!isEmpty(equipment) && this.state.currentEquipment && (
          <Container className="mt-2 pr-4 pl-4">
            <div style={{ backgroundColor: '#fff', borderRadius: 30 }}>
              <Row className="mt-2 pl-4 pr-4 text-center">
                <Col className="pt-4 pb-1">
                  {this.state.currentEquipment &&
                    this.state.currentEquipment.videoUrl && (
                      <div className="player-wrapper">
                        <ReactPlayer
                          className="react-player"
                          url={this.state.currentEquipment.videoUrl}
                          width="100%"
                          height="100%"
                        />
                      </div>
                    )}
                  {this.state.currentEquipment.imageUrl &&
                    !this.state.currentEquipment.videoUrl && (
                      <img
                        alt="view of equipment"
                        style={{ borderRadius: 30 }}
                        className="img-fluid text-center"
                        src={this.state.currentEquipment.imageUrl}
                      />
                    )}
                  <p
                    className="orange-title text-center pt-3"
                    style={{ fontSize: '1.1rem' }}
                  >
                    {this.state.currentEquipment.name}
                  </p>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.currentEquipment.instructions,
                    }}
                  />
                </Col>
              </Row>
              <Row
                className="text-center pb-4"
                style={{ flexDirection: 'space-between' }}
              >
                <Col className="text-right">
                  <img
                    alt="go back"
                    style={{ width: 40 }}
                    src={arrowLeft}
                    onClick={() => this.prev()}
                  />
                </Col>
                <Col className="text-left">
                  <img
                    alt="go forward"
                    style={{ width: 40 }}
                    src={arrowRight}
                    onClick={() => this.next()}
                  />
                </Col>
              </Row>
            </div>
          </Container>
        )}

        {official && (
          <Container
            id="leaderboard"
            className="mt-4 pb-4 pl-5 pr-5"
            style={{ backgroundColor: '#fff' }}
          >
            <Row className="mt-2 pt-4">
              <Col>
                <p className="orange-title text-center">Leaderboards</p>
              </Col>
            </Row>
            <Nav className="rounded-tabs" fill tabs>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.tab === 'casual',
                  })}
                  onClick={() => this.setState({ tab: 'casual' })}
                >
                  CASUAL TIMES
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.tab === 'event' })}
                  onClick={() => this.setState({ tab: 'event' })}
                >
                  COMPETITION TIMES
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.tab}>
              <TabPane tabId="casual">
                <LeaderBoardPane data={unofficial} />
              </TabPane>
              <TabPane tabId="event">
                <LeaderBoardPane data={official} />
              </TabPane>
            </TabContent>
          </Container>
        )}

        {!loading && !isEmpty(single) && !isEmpty(upcoming) && !isEmpty(past) && (
          <Container
            id="events"
            className="mt-4 pb-4 pl-5 pr-5"
            style={{ marginBottom: 100 }}
          >
            <Row className="mt-2 pt-4">
              <Col>
                <p className="orange-title text-center">Events</p>
              </Col>
            </Row>
            <Nav className="rounded-tabs tabs-white-bg" fill tabs>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.eventTab === 'upcoming',
                  })}
                  onClick={() => this.setState({ eventTab: 'upcoming' })}
                >
                  UPCOMING EVENTS
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.eventTab === 'past',
                  })}
                  onClick={() => this.setState({ eventTab: 'past' })}
                >
                  CURRENT AND PAST EVENTS
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.eventTab}>
              <TabPane tabId="upcoming">
                <EventPane data={upcoming} singleId={single.id} />
              </TabPane>
              <TabPane tabId="past">
                <EventPane data={past} singleId={single.id} />
              </TabPane>
            </TabContent>
          </Container>
        )}
        <div
          className="text-center"
          style={{
            position: 'fixed',
            bottom: 0,
            width: '100%',
            backgroundColor: '#fff',
          }}
        >
          <Button
            style={{
              width: '85%',
              backgroundColor: '#62B522',
              borderRadius: '1.5rem',
              marginTop: 15,
              marginBottom: 15,
              fontWeight: 'bold',
              border: 'none',
            }}
            onClick={() => this.setState({ isOpen: true })}
          >
            <img src={clockButton} className="pr-2" alt="clock icon" />
            OPEN COURSE TIMER!
          </Button>
        </div>

        <Modal className="timer-modal" isOpen={this.state.isOpen}>
          <ModalBody style={{ borderRadius: 30 }}>
            <h6
              className="text-right"
              onClick={() => this.setState({ isOpen: false })}
            >
              Close
            </h6>
            <Stopwatch
              user={user}
              saveTime={this.saveTime}
              didRegister={didRegister}
              timeSaved={timeSaved}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.auth;
  const { didRegister } = state.account;
  const { single, loading } = state.location;
  const { equipment } = state.locationEquipment;
  const { official, unofficial, timeSaved } = state.leaderboard;
  const { upcoming, past } = state.event;

  return {
    single,
    loading,
    equipment,
    official,
    unofficial,
    user,
    didRegister,
    timeSaved,
    upcoming,
    past,
  };
}

const mapDispatchToProps = {
  getLocation: locationActions.getSingle,
  addToLeaderboard: leaderboardActions.addToLeaderboard,
  equipmentForSite: locationEquipmentActions.getSiteEquipment,
  getLeaderboard: leaderboardActions.listResults,
  getUpcoming: eventActions.getUpcoming,
  getPast: eventActions.getPast,
};
const connectedLocationSingle = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LocationSingle);
export { connectedLocationSingle as LocationSingle };
